import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { OrderModel } from '@core/api';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { OrderTimeService } from '@core/components/services/order-time.service';
import { OrderService } from '@accounts/user/services/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UnexpectedErrorMessageService } from '@core/services';
import { finalize } from 'rxjs/operators';
import { UnexpectedErrorComponent } from '@ui/ui-errors';
import { ConfirmationDialogService } from '@ui/confirmation-dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'trailer-reserve-done',
  templateUrl: './trailer-reserve-done.component.html',
  styleUrls: ['./trailer-reserve-done.component.scss']
})
export class TrailerReserveDoneComponent implements OnDestroy {

  @Output() onCreateOrder = new EventEmitter<boolean>();
  @Input() order: OrderModel;
  loading = false;
  createOrder$: Subscription;

  constructor(
    private orderService: OrderService,
    private router: Router,
    private snackBar: UnexpectedErrorMessageService,
    private orderTimeService: OrderTimeService,
    private i18n: I18n,
    private confirmationDialogService: ConfirmationDialogService,
  ) { }

  closeDialog() {
    this.onCreateOrder.emit(false);
  }
  beginReserve() {
    this.loading = true;
    if (this.order.returnGasStation && this.order.returnGasStation.id) {
      this.order.return_gas_station_id = this.order.returnGasStation.id;
    }
    this.createOrder$ = this.orderService.createOrder(this.order)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        () => {

          this.router.navigate(['/cabinet/active']);
        },
        error => {
          this.snackBar.openFromComponent(UnexpectedErrorComponent);
          console.log(error);
        }
      );
  }
  get rentTime(): string {
    return this.orderTimeService.getStringOrderTime(this.order.tariff_type, this.order.rent_hours);
  }

  get cost(): number {
    return this.order.cost;
  }

  get stationAddressRentBegin(): string {
    return this.order.gasStation.address;
  }

  //todo: need to fix on the return station address
  get stationAddressRentEnd(): string {
    if (this.order.returnGasStation) {
      return this.order.returnGasStation.address;
    }

    return this.order.gasStation.address;
  }

  rejectOrder() {
    return this.confirmationDialogService.confirm({
      cancelBtnText: this.i18n('Назад'),
      confirmBtnText: this.i18n('Отменить'),
      message: this.i18n('Вы действительно хотите отменить бронирование?'),
      title: this.i18n('Отмена бронирования')
    })
      .then(() => {
        this.router.navigate(['/cabinet/new']);
      })      
  }

  ngOnDestroy() {
    this.createOrder$ && this.createOrder$.unsubscribe();
  }
}
